export default __webpack_public_path__ + "static/media/download-section-mobile.9d7a1b72.webp";